const gstStateMapping = {
    "01": "Jammu & Kashmir",
    "02": "Himachal Pradesh",
    "03": "Punjab",
    "04": "Chandigarh",
    "05": "Uttarakhand",
    "06": "Haryana",
    "07": "Delhi",
    "08": "Rajasthan",
    "09": "Uttar Pradesh",
    "10": "Bihar",
    "11": "Sikkim",
    "12": "Arunachal Pradesh",
    "13": "Nagaland",
    "14": "Manipur",
    "15": "Mizoram",
    "16": "Tripura",
    "17": "Meghalaya",
    "18": "Assam",
    "19": "West Bengal",
    "20": "Jharkhand",
    "21": "Odisha",
    "22": "Chhattisgarh",
    "23": "Madhya Pradesh",
    "24": "Gujarat",
    "25": "Daman & Diu",
    "26": "Dadra & Nagar Haveli",
    "27": "Maharashtra",
    "28": "Andhra Pradesh (Before Split)",
    "29": "Karnataka",
    "30": "Goa",
    "31": "Lakshadweep",
    "32": "Kerala",
    "33": "Tamil Nadu",
    "34": "Puducherry",
    "35": "Andaman & Nicobar Islands",
    "36": "Telangana",
    "37": "Andhra Pradesh (New)"
  };
  
  export const getStateFromGST = (gstNumber) =>{
    if(!gstNumber){
        return "Invalid GST Number";
    }
    const stateCode = gstNumber.substring(0,2);
    return gstStateMapping[stateCode] || "NA"
  }

  /** Reverse lookup: party state name → 2-digit GST state code (e.g. Gujarat → 24). */
  export const getStateCodeFromStateName = (stateName) => {
    if (stateName == null) return "NA";
    const normalized = String(stateName).trim().toLowerCase();
    if (!normalized) return "NA";
    for (const [code, name] of Object.entries(gstStateMapping)) {
      if (String(name).trim().toLowerCase() === normalized) {
        return code;
      }
    }
    return "NA";
  };